exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll {\n  overflow: auto;\n  max-height: 400px;\n  min-height: 400px;\n}\n\n.loading_data_icon {\n  position: absolute;\n  display: block;\n  right: 10px;\n  top: 25px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/purchasehistory/purchasehistory.component.css
// module id = ../../../../../src/app/shared/component/purchasehistory/purchasehistory.component.css
// module chunks = main